import upperFirst from 'lodash/upperFirst';

export type CalculateTestIdInput = {
	actionSubjectId?: string;
	source: string;
};

export const calculateTestId = ({ actionSubjectId, source }: CalculateTestIdInput) =>
	actionSubjectId !== undefined ? `${source}${upperFirst(actionSubjectId)}` : undefined;
